<template>
  <div id="app">
    <!-- ナビゲーション -->
    <b-navbar toggleable="md" class="shadow-sm" variant="light" type="light">
      <b-navbar-nav>
        <b-button variant="link" to="/list">&lt; 戻る</b-button>
      </b-navbar-nav>
      <b-navbar-brand to="/" class="ml-3 mr-3">
        <span class>{{ this.name }}</span>
        <span class="ml-2">部屋</span>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-button
            class="ml-1"
            variant="outline-primary"
            @click="viewRequestList"
          >参加人数 {{this.requestList.filter((req)=> req.isAccept).length}} 人 ・ 参加申請数 {{this.requestList.filter((req)=>!req.isAccept).length}}</b-button>

          <b-button class="ml-2" variant="outline-primary" @click="reload">リロード</b-button>

          <b-nav-item-dropdown text="アドレス">
            <b-dropdown-text>{{'https://master.d1pjjmf6on1sf7.amplifyapp.com/room/' + this.roomId}}</b-dropdown-text>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto align-items-center">
          <b-nav-text>使用ゲーム : {{this.game.title}}</b-nav-text>

          <b-button
            v-if="isRoomMaster2 && this.game.id !== ''"
            class="ml-2"
            variant="outline-primary"
            :href="'/game/' + this.game.id"
          >ゲームを編集</b-button>
          <b-button
            v-if="isRoomMaster2 && this.game.id !== ''"
            class="ml-2"
            variant="outline-primary"
            @click="resetRoom"
          >ゲーム情報を再読み込み</b-button>

          <b-button
            v-if="isRoomMaster2"
            class="ml-2"
            variant="outline-primary"
            @click="deleteRoom"
          >部屋を削除</b-button>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- 入室申請一覧 モーダル-->
    <b-modal
      id="request-modal"
      centered
      scrollable
      no-close-on-backdrop
      :hide-footer="!isViewRequestForm"
      title="参加者一覧"
      footer-class="d-flex flex-column align-items-center"
    >
      <div v-for="request in requestList" :key="request.id">
        <div class="d-flex align-items-center">
          <span>名前 : {{request.name}}</span>
          <span class="ml-1" v-if="isRoomMaster(request.userName)">(管理人)</span>
          <span class="ml-2">
            <span v-if="request.isAccept">[参加中]</span>
            <span v-else>[管理者による承認待ち]</span>
          </span>
          <span class="ml-auto">
            <b-button
              class="ml-2"
              v-if="isRoomMaster2 && !request.isAccept"
              variant="outline-primary"
              @click="onAccept(request)"
            >許可</b-button>
            <b-button
              class="ml-1"
              v-if="isRoomMaster2 || isRequestOwner(request.userName)"
              variant="outline-primary"
              @click="onDeleteRequestAction(request)"
            >参加取り消し</b-button>
          </span>
        </div>
      </div>
      <template v-slot:modal-footer v-if="isViewRequestForm">
        <div class="d-flex flex-column align-items-center">
          <div class="mb-1">この部屋に参加しますか？</div>
          <b-form inline @submit.prevent="onCreateRequest">
            <b-form-group label="名前 : " label-for="nameInput">
              <b-form-input
                class
                type="text"
                id="nameInput"
                v-model="createRequestForm.name"
                placeholder
              ></b-form-input>
            </b-form-group>

            <div class="d-flex ml-2">
              <b-button type="submit" variant="outline-primary" class="mr-1">参加する</b-button>
            </div>
          </b-form>
        </div>
      </template>
    </b-modal>

    <!-- ルームが見つからない場合 -->
    <div class="container" v-if="viewState === 0">このルームは存在しません。また新しく作ろう。</div>

    <!-- ルームはあるが権限がない場合 または初期値-->
    <div v-if="viewState === 1 || viewState === 3"></div>

    <!-- ルーム -->
    <div class="d-flex flex-wrap mt-2" v-if="viewState === 2">
      <!-- ユーザー一覧情報 -->
      <div class="ml-4">
        <!-- ゲスト一覧表示部分 -->
        <div class="mt-2">
          <h4>プレイヤー一覧</h4>
          <div class="mt-3">
            <guest-view
              v-for="guest in guestList"
              :key="guest.id"
              :guest="guest"
              :card-list="cardList"
              :character-list="characterList"
              :group-list="groupList"
              :guest-list="guestList"
              :is-room-master="isRoomMaster(guest.userName)"
              @removeGuestAction="removeGuestAction(guest,true)"
              @onMoveCardForm="onMoveCardForm"
              @updateAll="updateAllRoomData"
            ></guest-view>
          </div>

          <!-- ゲスト追加フォーム -->
          <!-- <add-guest-form :room-id="this.roomId" v-if="isAddedGuest"></add-guest-form> -->
        </div>
        <!-- グループ一覧 -->
        <div class="mt-4">
          <div class="d-flex mb-2 align-items-center">
            <h4>密談場所</h4>
            <span class="ml-2" v-if="isJoinGroup">
              あなた :
              <b-button
                variant="outline-primary"
                @click="removeGroupAction($store.state.user.username)"
              >密談をやめる</b-button>
            </span>
          </div>
          <div>
            <!-- グループ -->
            <div
              class="border rounded py-2 px-2 mb-1"
              v-for="(group, idx) in groupList"
              :key="group.id"
            >
              <div class="flex-grow-1 mb-1">
                <span class="mr-3">ID : {{ idx }}</span>
                <span>
                  メンバー :
                  {{ group.members.map(getGameName).join(" ・ ") }}
                </span>
              </div>
              <div>
                <span v-if="isJoinGuest">
                  あなた :
                  <b-button variant="outline-primary" @click="joinGroupAction(group.id)">この密談に参加する</b-button>
                </span>
                <span>
                  指名 :
                  <b-button variant="outline-primary" @click="joinGroupAction2(group.id)">参加させる</b-button>
                </span>
                <span>
                  <b-button
                    class="ml-2"
                    variant="outline-primary"
                    @click="deleteGroupAction(group.id)"
                  >密談場所を削除</b-button>
                </span>
              </div>

              <!-- グループ退出 -->
              <!-- <b-form inline @submit.prevent="onRemoveGroupForm(group.id)">
                <b-form-group label="退出" label-for="targetGuest">
                  <b-form-select
                    id="targetGuest"
                    v-model="joinGroupEvent.member"
                    :options="getSelectOption"
                  ></b-form-select>
                </b-form-group>

                <div class="d-flex flex-row-reverse">
                  <b-button type="submit" variant="outline-primary" class="mr-1"
                    >退出する</b-button
                  >
                </div>
              </b-form>-->
            </div>

            <div class="border rounded py-2 pl-4 mb-1 d-flex align-items-center">
              <b-button
                @click="onCreateGroupForm"
                variant="outline-primary"
                class="ml-auto mr-2"
              >新しい密談場所を作成する</b-button>
            </div>
            <!-- グループ参加フォーム -->
            <b-modal id="group-form-modal" hide-footer>
              <template v-slot:modal-title>メンバーを編集</template>
              <b-form inline @submit.prevent="onJoinGroupForm">
                <b-form-group label="名前" label-for="targetGuest">
                  <b-form-select
                    id="targetGuest"
                    v-model="joinGroupEvent.member"
                    :options="getSelectOption"
                  ></b-form-select>
                </b-form-group>

                <div class="d-flex flex-row-reverse">
                  <b-button type="submit" variant="outline-primary" class="mr-1">追加</b-button>
                </div>
              </b-form>
            </b-modal>
          </div>
        </div>
      </div>

      <!-- ゲーム情報 -->
      <div class="ml-4">
        <!-- タイトル -->
        <div class="d-flex mt-2">
          <h3 v-if="this.game.id !== ''">{{ this.game.title }}</h3>
          <h4 v-else>ゲームが設定されていません</h4>
        </div>
        <!-- 説明 -->
        <div class="mt-2">{{ this.game.description }}</div>

        <!-- 使うカード一覧 -->
        <div class="mt-5">
          <h4 class="mb-3">調査・手掛り</h4>
          <div class="d-flex align-items-center">
            <span class>
              <b-button variant="outline-primary" @click="DealCards">カードを各フィールドに 2 枚ずつ配る</b-button>
            </span>
            <span class="ml-2">( デッキ残り枚数 {{sumNotDealCards}}枚)</span>
          </div>

          <div class="d-flex mt-1">
            <div v-for="(value, key) in deck" :key="`1-${key}`">
              <div class="border">
                <!-- フィールド名 -->
                <div class="m-2">{{ key }}</div>
                <!-- カード -->
                <div
                  class="d-flex flex-column m-2 p-2 game-card"
                  v-for="card in isDealCards(value)"
                  :key="card.id"
                >
                  <b-card class="border-0">
                    <div>表 : {{ card.faceUpString }}</div>
                  </b-card>
                  <b-button variant="outline-primary" @click="showMoveModal(card.id)">カードの移動</b-button>
                </div>
              </div>
            </div>
            <!-- 移動フォーム モーダル -->
            <b-modal id="move-modal" hide-footer>
              <template v-slot:modal-title>カードを移動する</template>
              <b-form
                inline
                class="col"
                @submit.prevent="onMoveCardForm('move-modal',moveCardEvent)"
              >
                <b-form-group label="相手" label-for="targetGuest">
                  <b-form-select
                    id="targetGuest"
                    v-model="moveCardEvent.editor"
                    :options="getSelectOption"
                  ></b-form-select>
                </b-form-group>

                <div class="d-flex flex-row-reverse">
                  <b-button type="submit" variant="outline-primary" class="mr-1">移動</b-button>
                </div>
              </b-form>
            </b-modal>
          </div>
        </div>
        <!-- 全体画像データ -->
        <div class="mt-4">
          <h4 class="mb-0">画像</h4>
          <div class="d-flex mt-0">
            <amplify-s3-album class="mt-0" v-if="game.id" :path="game.id + '/zentai/'" />
          </div>
        </div>

        <!-- キャラクター -->
        <div class="mt-4">
          <h4>登場人物一覧</h4>
          <div class="mt-3">
            <b-card v-for="character in characterList" :key="character.id" :title="character.name">
              <!-- <amplify-s3-album
              :path="game.id + '/' + character.name + '/open'"
              />-->
              <div class="d-flex justify-content-end">
                <b-button
                  variant="outline-primary"
                  @click="showSelectCharacterModal(character.id)"
                >ロールする人を選ぶ</b-button>
              </div>
            </b-card>
          </div>
        </div>

        <!-- キャラ選択モーダル -->
        <b-modal id="selectCharacter-modal" hide-footer>
          <b-card class="mb-2" title="キャラクターを演じる人を決定する">
            <b-form class="col" @submit.prevent="onChracterSelectForm">
              <b-form-group label="ロールする人" label-for="targetGuest">
                <b-form-select
                  id="targetGuest"
                  v-model="characterSelectEvent.editor"
                  :options="getSelectOption"
                ></b-form-select>
              </b-form-group>

              <div class="d-flex flex-row-reverse">
                <b-button type="submit" variant="outline-primary" class="mr-1">選択</b-button>
              </div>
            </b-form>
          </b-card>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { getRoom, listRequests } from "../graphql/queries";
import {
  onUpdatedRoom,
  onCreateGuest,
  onDeleteGuest,
  onDeleteRequest,
  onCreateRequest,
  onUpdateRequest
} from "../graphql/subscriptions";
import {
  // updateRoom,
  deleteRoom,
  deleteGuest,
  createRequest,
  createGuest,
  updateRequest,
  deleteRequest
  // deleteRequest
} from "../graphql/mutations";

import GuestView from "../components/GuestView.vue";

import { graphqlQuery } from "../util/queryUtil";
import UserStore from "@/store/index.js";
import { getRoom2 } from "../graphql2/queries";
// import { onUpdateRoom } from "@/graphql2/subscriptions";
import { updateRoom } from "@/graphql2/mutations";

class ViewState {
  constructor() {
    this.NotFound = 0;
    this.NotAuthorizedtoAccess = 1;
    this.JoinRoom = 2;
    this.Init = 3;
  }
}

export default {
  name: "App",
  components: { GuestView },
  data() {
    return {
      viewState: new ViewState().Init,

      owner: "",
      editors: [],

      requestList: [],

      roomId: "",
      name: "",
      game: { id: "", title: "", description: "" },

      guestList: [],
      cardList: [],
      characterList: [],
      groupList: [],

      fieldTagList: [],

      photoPickerConfig: {
        header: "画像をアップロードする",
        accept: "image/*",
        path: `${this.$route.params.roomName}/`,
        defaultName: "test"
      },

      moveCardEvent: {
        id: "",
        editor: ""
      },

      characterSelectEvent: {
        id: 0,
        editor: ""
      },

      joinGroupEvent: {
        id: "",
        member: ""
      },

      createRequestForm: {
        name: "",
        userName: UserStore.state.user.username
      },

      deck: {}
    };
  },
  methods: {
    _firstSetup(roomData) {
      // console.log("roomData first Set up", roomData);
      //初めての場合ゲームの初期状態をコピーしながらルーム用のデータに変更
      if (roomData.game != null && roomData != null) {
        // 初期状態を追加
        this.cardList = roomData.game.cards.map(card => {
          card.isDeal = false;
          card.editor = null;
          card.isAllOpen = false;
          card.isGroupOpen = false;
          return card;
        });
        this.characterList = roomData.game.characters.map(chara => {
          chara.editor = null;
          return chara;
        });

        // console.log(this.cardList);
        // ２枚ずつ配る
        this.fieldTagList = roomData.game.fieldTags;
        this.pareCards();
        // console.log("this.deck", Object.keys(this.deck));
        this.DealCards();
        // console.log("cardList", this.cardList);
        // console.log("before first setup update query");
        //コピーしたことをサーバーへ
        graphqlQuery(
          this,
          updateRoom,
          {
            input: {
              id: roomData.id,
              name: roomData.name,
              isCopiedGame: true,
              cards: this.cardList,
              characters: this.characterList,
              gameId: roomData.gameId,
              gameTitle: roomData.game.title,
              gameDescription: roomData.game.description,
              fieldTags: this.fieldTagList,
              groups: roomData.groups,
              editors: roomData.editors
            }
          },
          result__ => {
            // console.log("after first set up ", result__);
            this._setUpData(result__.data.updateRoom);

            // ゲストのサブスクを設定
            this.guestSubscribe();

            // ルームのサブスクを設定
            this.roomSubscribe();

            // 入室申請のサブスク設定
            this.requestSubscribe();
          }
        );
      }
    },

    // データの移し替え
    _setUpData(roomData) {
      // console.log("set up data");
      // console.log(roomData);

      // なかったらnot found表示
      if (roomData == null) {
        this.viewState = new ViewState().NotFound;
        return;
      }

      // データ移し替え
      this.roomId = roomData.id;
      this.owner = roomData.owner;
      this.editors = roomData.editors;

      this.name = roomData.name;
      this.game.id = roomData.gameId;
      this.game.title = roomData.gameTitle;
      this.game.description = roomData.gameDescription;
      this.isCopiedGame = roomData.isCopiedGame;

      this.guestList = roomData.guests.items;
      this.groupList = roomData.groups;
      this.requestList = roomData.requests.items;
      this.cardList = roomData.cards;
      this.characterList = roomData.characters;
      this.fieldTagList = roomData.fieldTags;

      this.pareCards();
    },

    // 移動モーダルを表示
    showMoveModal(id) {
      this.moveCardEvent.id = id;
      this.$bvModal.show("move-modal");
    },

    // キャラセレクトモーダルを表示
    showSelectCharacterModal(id) {
      this.characterSelectEvent.id = id;
      this.$bvModal.show("selectCharacter-modal");
    },

    // ルームデータの取得
    getRoomData() {
      var value = {
        id: this.roomId
      };
      // console.log("get room data");
      graphqlQuery(this, getRoom, value, result => {
        // console.log("get room data result : ", result);
        this._setUpData(result.data.getRoom);
      });
    },

    // guestの変更を反映
    guestSubscribe() {
      this.$Amplify.API.graphql({ query: onCreateGuest }).subscribe({
        next: diff => {
          // console.log(diff);
          if (
            this.roomId === diff.value.data.onCreateGuest.roomId &&
            !this.guestList.some(
              guest => guest.id === diff.value.data.onCreateGuest.id
            )
          ) {
            this.guestList.push(diff.value.data.onCreateGuest);
          }
        }
      });

      this.$Amplify.API.graphql({ query: onDeleteGuest }).subscribe({
        next: diff => {
          // console.log("onDeleteGuest", diff);
          if (
            this.roomId === diff.value.data.onDeleteGuest.roomId &&
            this.guestList.some(
              guest => guest.id === diff.value.data.onDeleteGuest.id
            )
          ) {
            this.removeGuestAction(diff.value.data.onDeleteGuest, false);
          }
        }
      });
    },

    subscribePattern(sql, sqlName, listName) {
      // console.log(sql);

      this.$Amplify.API.graphql({ query: sql }).subscribe({
        error: error => {
          console.error(error);
        },
        next: diff => {
          let changeData = diff.value.data[sqlName];
          // console.log(sqlName);
          // console.log(diff);
          // console.log(diff.value.data[sqlName].roomId);
          // console.log(sqlName, this[listName]);
          if (this.roomId === changeData.roomId) {
            let idx = this[listName].findIndex(val => val.id === changeData.id);
            // console.log(idx);
            if (idx === -1) {
              this[listName].push(changeData);
            } else {
              this[listName].splice(idx, 1, changeData);
              if (
                changeData.userName === UserStore.state.user.username &&
                this.owner !== changeData.username &&
                changeData.isAccept
              ) {
                this.reload();
              }
            }
            // console.log(this);
            // console.log(list);
            // console.log(list);
          }
        }
      });
    },
    subscriveDelete(sql, sqlName, listName) {
      // console.log(sql);

      this.$Amplify.API.graphql({ query: sql }).subscribe({
        error: error => {
          console.error(error);
        },
        next: diff => {
          let deleteData = diff.value.data[sqlName];
          // console.log(diff);
          // console.log(diff.value.data[sqlName]);
          if (this.roomId === deleteData.roomId) {
            // console.log(list);
            this[listName] = this[listName].filter(
              req => req.id !== deleteData.id
            );

            if (
              deleteData.userName === UserStore.state.user.username &&
              this.owner !== deleteData.username
            ) {
              this.reload();
            }
          }
        }
      });
    },
    // requestの変更を反映
    requestSubscribe() {
      this.subscribePattern(onCreateRequest, "onCreateRequest", "requestList");
      this.subscriveDelete(onDeleteRequest, "onDeleteRequest", "requestList");

      this.subscribePattern(onUpdateRequest, "onUpdateRequest", "requestList");
    },

    // 部屋データのサブスクライブを設定
    roomSubscribe() {
      let value = {
        owner: this.owner,
        editors: this.editors
      };

      // console.log("room Subsc", value);

      this.$Amplify.API.graphql({
        query: onUpdatedRoom,
        variables: value
      }).subscribe({
        error: error => {
          console.error(error);
        },
        next: diff => {
          console.log("room Subsc diff", diff);
          if (this.roomId === diff.value.data.onUpdatedRoom.id) {
            this._setUpData(diff.value.data.onUpdatedRoom);
            if (
              this.editors.toString() !==
              diff.value.data.onUpdatedRoom.editors.toString()
            ) {
              // console.log(
              //   "subsc set from onUpdate room",
              //   this.editors.toString(),
              //   diff.value.data.onUpdatedRoom.editors.toString()
              // );

              this.roomSubscribe();
            }
          }
        }
      });
    },

    // カードの移動
    moveCard(cardId, editor) {
      if (editor === "") {
        console.error("not select card owner");
        return;
      }
      // console.log(this.cardList);

      let targetCard = this.cardList.find(card => {
        // console.log(cardId);
        return card.id === cardId;
      });

      // console.log(targetCard);
      if (targetCard == null) {
        console.error("targetCard is null or undefind");
      }
      // 所有者の移動
      targetCard.editor = editor;
      // console.log("card List after move card", this.cardList);
      targetCard.isAllOpen = false;
      targetCard.isGroupOpen = false;

      // カードをフィールドに表示
      this.pareCards();
    },

    // 移動モーダルのクリック
    onMoveCardForm(modalId, moveCardEvent) {
      if (!moveCardEvent.editor) {
        return;
      }
      //モーダルの削除
      this.$bvModal.hide(modalId);

      // console.log(modalId, moveCardEvent);

      this.moveCard(moveCardEvent.id, moveCardEvent.editor);

      // DB更新
      this.updateAllRoomData();
    },

    // 部屋の状態をゲーム初期状態に戻す。
    resetRoom() {
      graphqlQuery(
        this,
        updateRoom,
        {
          input: {
            id: this.roomId,
            isCopiedGame: false
          }
        },
        () => this.reload()
      );
    },

    // 部屋を削除
    deleteRoom() {
      graphqlQuery(this, deleteRoom, { input: { id: this.roomId } }, () => {
        // console.log(result);
        this.viewState = new ViewState().NotFound;
      });
    },

    // ロールを設定
    selectCharacter() {
      let targetCharacter = this.characterList.find(chara => {
        // console.log(card);
        return chara.id === this.characterSelectEvent.id;
      });

      targetCharacter.editor = this.characterSelectEvent.editor;
    },

    // キャラクターを選択
    onChracterSelectForm() {
      //モーダルの削除
      this.$bvModal.hide("selectCharacter-modal");
      this.selectCharacter();
      this.updateAllRoomData();
    },

    // ユニークな文字列生成、ネットからコピペ
    getUniqueStr(myStrong) {
      var strong = 1000;
      if (myStrong) strong = myStrong;
      return (
        new Date().getTime().toString(16) +
        Math.floor(strong * Math.random()).toString(16)
      );
    },

    // グループを作成
    onCreateGroupForm() {
      this.groupList.push({ id: this.getUniqueStr(), members: [] });

      this.updateAllRoomData();
    },

    // 自分の登録しているゲストを取得
    getCurrentGest() {
      const guest = this.guestList.find(
        g => g.userName === UserStore.state.user.username
      );
      if (guest) {
        return guest;
      } else {
        return null;
      }
    },

    // グループからゲストuserNameを使って、削除する
    removeGroupAction(userName) {
      if (userName == null) {
        return;
      }

      this.groupList.forEach(g => {
        // userName以外のみにする
        g.members = g.members.filter(str => {
          // console.log(str);
          return str !== userName;
        });
      });
    },

    // グループに参加する 移動もする
    joinGroupAction(id) {
      if (this.getCurrentGest() == null) {
        return;
      }

      let userGuest = this.getCurrentGest();

      this.removeGroupAction(userGuest.userName);
      let group = this.groupList.find(g => g.id === id);
      group.members.push(userGuest.userName);
      this.updateAllRoomData();
    },

    // グループ編集モーダル呼び出し
    joinGroupAction2(id) {
      this.$bvModal.show("group-form-modal");
      this.joinGroupEvent.id = id;
    },

    // グループに参加、モーダル、フォームバージョン
    onJoinGroupForm() {
      //モーダルの削除
      this.$bvModal.hide("group-form-modal");
      // console.log(this.joinGroupEvent);

      this.removeGroupAction(this.joinGroupEvent.member);
      let group = this.groupList.find(g => g.id === this.joinGroupEvent.id);

      group.members.push(this.joinGroupEvent.member);
      this.updateAllRoomData();
    },

    // 自分のゲーム名
    getGameName(userName) {
      let guest = this.guestList.find(guest => guest.userName === userName);
      if (guest) {
        return guest.name;
      }
      return null;
    },

    // グループを削除
    deleteGroupAction(id) {
      this.groupList = this.groupList.filter(g => g.id !== id);
      this.updateAllRoomData();
    },

    // ルーム情報ゲスト以外全更新
    updateAllRoomData(f) {
      let value = {
        input: {
          id: this.roomId,
          cards: this.cardList,
          characters: this.characterList,
          groups: this.groupList,
          name: this.name,
          gameId: this.game.id,
          gameTitle: this.game.title,
          gameDescription: this.game.description,
          fieldTags: this.fieldTagList,
          isCopiedGame: this.isCopiedGame,
          editors: this.editors
        }
      };
      // console.log("update room value", value);
      graphqlQuery(this, updateRoom, value, result => {
        // console.log("update room", result);
        this._setUpData(result.data.updateRoom);
        if (f != null) {
          f();
        }
      });
    },

    // ゲスト削除
    removeGuestAction(guest, isUpload) {
      // console.log(this.cardList);
      this.guestList = this.guestList.filter(gue => gue.id !== guest.id);
      // カードデータの消去
      this.cardList = this.cardList.map(card => {
        // console.log(card);
        if (card.editor === guest.userName) {
          card.editor = null;
        }
        return card;
      });
      this.characterList = this.characterList.map(chara => {
        if (chara.editor === guest.userName) {
          chara.editor = null;
        }
        return chara;
      });
      //グループデータ消去
      this.removeGroupAction(guest.userName);

      // ゲストデータの消去
      graphqlQuery(this, deleteGuest, { input: { id: guest.id } }, () => {
        // console.log(result);
        if (isUpload) {
          this.updateAllRoomData(() => {});
        }
      });
    },

    // フィールドにカードを並べる
    pareCards() {
      this.deck = {};
      // 決められたタグのリスト
      this.fieldTagList.forEach(tag => (this.deck[tag] = []));

      this.cardList.forEach(card => {
        // タグがあって、所有者がないものは追加
        if (this.deck[card.tag] != undefined && card.editor == null) {
          this.deck[card.tag].push(card);
        } else {
          // deck[card.tag] = [card];
        }
      });
      // console.log(this.cardList);
      // console.log(this.deck);
    },

    // カードをフィールドごとに、2枚まで配る
    DealCards() {
      Object.keys(this.deck).forEach(key => {
        if (this.deck[key].length === 0) {
          return;
        }
        // 2枚まで
        for (let index = 0; index < 2; index++) {
          let count = this.deck[key].filter(card => card.isDeal).length;
          // console.log(count);
          let notDeckedCardList = this.deck[key].filter(card => !card.isDeal);

          if (count >= 2 || notDeckedCardList.length === 0) {
            return;
          } else {
            let randomNum = Math.floor(
              Math.random() * notDeckedCardList.length
            );
            let card = notDeckedCardList[randomNum];
            card.isDeal = true;
          }
        }
      });

      // this.updateAllRoomData();
    },

    // 申請一覧を取得
    getRequestList() {
      graphqlQuery(
        this,
        listRequests,
        { filter: { roomId: { eq: this.roomId } }, limit: 1000 },
        result => {
          this.requestList = result.data.listRequests.items;
          this.$bvModal.show("request-modal");
        }
      );
    },

    // 申請を作成
    onCreateRequest() {
      if (this.createRequestForm.name === "") {
        return;
      }

      let isAccept =
        this.owner === UserStore.state.user.username ? true : false;

      const value = {
        input: Object.assign(
          { roomId: this.roomId, isAccept: isAccept },
          this.createRequestForm
        )
      };
      graphqlQuery(this, createRequest, value, result => {
        //フォームリセット
        this.createRequestForm.name = "";
        this.requestList.push(result.data.createRequest);

        if (this.owner === UserStore.state.user.username) {
          graphqlQuery(
            this,
            createGuest,
            {
              input: {
                roomId: this.roomId,
                name: result.data.createRequest.name,
                userName: result.data.createRequest.userName
              }
            },
            () => {}
          );
        }
      });
    },

    viewRequestList() {
      // this.$bvModal.show("request-modal");
      this.getRequestList();
    },

    // 参加許可
    onAccept(request) {
      // console.log(request);
      this.editors.push(request.userName);
      // subscribe更新
      this.roomSubscribe();
      // editorの更新
      this.updateAllRoomData(() => {
        // requestのupdate
        if (this.guestList.some(gue => gue.userName === request.username)) {
          graphqlQuery(
            this,
            updateRequest,
            { input: { id: request.id, isAccept: true } },
            () => {
              // console.log(req);
            }
          );
        } else {
          graphqlQuery(
            this,
            createGuest,
            {
              input: {
                roomId: this.roomId,
                name: request.name,
                userName: request.userName
              }
            },
            newGuest => {
              this.guestList.push(newGuest.data.createGuest);
              graphqlQuery(
                this,
                updateRequest,
                { input: { id: request.id, isAccept: true } },
                () => {
                  // console.log(req);
                }
              );
            }
          );
        }
      });
    },

    // 参加欄から削除
    onDeleteRequestAction(request) {
      // 権限を剥奪
      this.editors = this.editors.filter(str => str !== request.userName);
      this.roomSubscribe();
      // ゲストから削除
      let targetList = this.guestList.filter(
        gue => gue.userName === request.userName
      );

      if (targetList.length > 0) {
        // ゲスト毎に反映
        targetList.forEach(guest => {
          this.removeGuestAction(guest, true);
        });
        this.guestList = this.guestList.filter(
          gue => gue.userName !== request.userName
        );
      }

      graphqlQuery(this, deleteRequest, { input: { id: request.id } }, () => {
        // console.log(result);
      });
    },

    reload() {
      this.$router.go();
    }
  },
  computed: {
    // ゲスト名一覧選択
    getSelectOption() {
      return this.guestList.map(guest => {
        return { value: guest.userName, text: guest.name };
      });
    },

    // 部屋に参加中かどうか
    isJoinRoom() {
      return (
        this.owner === UserStore.state.user.username ||
        this.editors.some(str => str === UserStore.state.user.username)
      );
    },

    isJoinGuest() {
      return this.guestList.some(
        guest => guest.userName === UserStore.state.user.username
      );
    },

    // グループに参加中かどうか
    isJoinGroup() {
      return this.groupList.some(group =>
        group.members.some(
          userName => userName === UserStore.state.user.username
        )
      );
    },

    // ルームマスターかどうか
    isRoomMaster() {
      return userName => this.owner === userName;
    },

    // ルームマスターかどうか２
    isRoomMaster2() {
      return this.owner === UserStore.state.user.username;
    },

    // すでに自分を参加者にしたか
    isAddedGuest() {
      return !this.guestList.some(
        guest => guest.userName === UserStore.state.user.username
      );
    },

    // 配られたカードのみのリスト
    isDealCards() {
      return list => {
        return list.filter(card => card.isDeal);
      };
    },

    // 各フィールドごとの残り枚数合計
    sumNotDealCards() {
      return Object.keys(this.deck).reduce((num, key) => {
        return num + this.deck[key].filter(card => !card.isDeal).length;
      }, 0);
    },

    isRequestOwner() {
      return str => str === UserStore.state.user.username;
    },

    isViewRequestForm() {
      return !this.requestList.some(
        req => req.userName === UserStore.state.user.username
      );
    }
  },

  mounted() {
    this.roomId = this.$route.params.roomName;
    // console.log(this.roomId);

    // Roomデータ取る
    this.$Amplify.API.graphql({
      query: getRoom2,
      variables: {
        id: this.roomId
      }
    })
      .then(result => {
        // console.log("get room");
        // console.log(result);

        // データあった場合
        this.viewState = new ViewState().JoinRoom;

        // なかったらnot found表示
        if (result.data.getRoom == null) {
          this.viewState = new ViewState().NotFound;
          return;
        }

        // 初回ゲーム情報のコピー
        if (!result.data.getRoom.isCopiedGame) {
          graphqlQuery(this, getRoom, { id: this.roomId }, result__ => {
            // console.log(result__.data.getRoom.groups);
            this._firstSetup(result__.data.getRoom);
          });
        } else {
          // console.log("normal get room");
          // console.log(result.data.getRoom);
          this._setUpData(result.data.getRoom);
          // ゲストのサブスクを設定
          this.guestSubscribe();

          // ルームのサブスクを設定
          this.roomSubscribe();

          // 入室申請のサブスク設定
          this.requestSubscribe();
        }
      })
      .catch(e => {
        // console.error(e);
        // console.log(UserStore.state.user.username);
        // 認証権限がない場合
        if (e.errors != null && e.errors[0].errorType === "Unauthorized") {
          console.log("not authorized to access!");
          this.viewState = new ViewState().NotAuthorizedtoAccess;

          // 参加申請のサブスク
          this.requestSubscribe();
          // 現在の参加状況を取得して表示
          this.getRequestList();
        } else {
          console.error(e);
        }
      });
  }
};
</script>

<style scoped>
.game-card {
  border: medium solid #dee2e6;
}
</style>
